import { NgModule } from "@angular/core";
import { CustomHexChoiceFieldDirective } from "./custom-hex-choicefield.directive";
import { CustomHexTextColorDirective } from "./custom-hex-text-color.directive";

@NgModule({
    imports: [],
    exports: [
        CustomHexChoiceFieldDirective,
        CustomHexTextColorDirective,
    ],
    declarations: [
        CustomHexChoiceFieldDirective,
        CustomHexTextColorDirective,
    ],
    providers: [],
})
export class OverridesModule {
}
